import script from "./asset-management-plan.vue?vue&type=script&setup=true&lang=ts"
export * from "./asset-management-plan.vue?vue&type=script&setup=true&lang=ts"

import "./asset-management-plan.vue?vue&type=style&index=0&id=0b84e453&lang=scss&scoped=true"
import "./asset-management-plan.vue?vue&type=style&index=1&id=0b84e453&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b84e453"]])

export default __exports__